import { render, staticRenderFns } from "./SafetyObservationViewForm.vue?vue&type=template&id=8e7b347e"
import script from "./SafetyObservationViewForm.vue?vue&type=script&lang=js"
export * from "./SafetyObservationViewForm.vue?vue&type=script&lang=js"
import style0 from "./SafetyObservationViewForm.vue?vue&type=style&index=0&id=8e7b347e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports